import _styled from "styled-components";
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { Button, Title } from '../../../';
import { useTranslation } from 'react-i18next';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ExitConfirmation(_ref) {
  var onExitApplication = _ref.onExitApplication,
      onCancel = _ref.onCancel;

  var _useTranslation = useTranslation('onboarding-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(ExclamationCircleIcon, {
        className: "w-8 h-8 text-red-800"
      }), /*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [/*#__PURE__*/_jsx(Title, {
          content: t('do_you_want_to_exit_spontaneous_application'),
          fontSize: "superLarge",
          fontWeight: "semibold",
          twStyle: {
            "lineHeight": "2.25rem"
          }
        }), /*#__PURE__*/_jsx(Title, {
          content: t('if_you_exit_progress_will_not_be_saved'),
          fontSize: "base",
          fontWeight: "normal",
          twStyle: {
            "lineHeight": "1.5rem"
          },
          textColor: "gray"
        })]
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv4, {
      children: [/*#__PURE__*/_jsx(Button, {
        title: t('yes_exit_application'),
        variant: "normal",
        fullwidth: true,
        onClick: onExitApplication
      }), /*#__PURE__*/_jsx(Button, {
        title: t('cancel'),
        variant: "secondary-outline",
        fullwidth: true,
        onClick: onCancel
      })]
    })]
  });
}
export default ExitConfirmation;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "exit-confirmation___StyledDiv",
  componentId: "sc-zbyxj8-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem",
  "paddingBottom": "0.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "exit-confirmation___StyledDiv2",
  componentId: "sc-zbyxj8-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "exit-confirmation___StyledDiv3",
  componentId: "sc-zbyxj8-2"
})({
  "display": "flex",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.5rem",
  "textAlign": "center"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "exit-confirmation___StyledDiv4",
  componentId: "sc-zbyxj8-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});